import { defineStore } from "pinia";
import { ref } from "vue";
import storage from "../utils/storage";
import { userApi } from "@/api/index.js";
import router from "@/router";

const data = storage.info();
export const useUserStore = defineStore("user", function () {
  const token = ref(data.token);

  // 设置标识
  function setToken(data) {
    // 请求的唯一标识
    token.value = data.token;
    storage.set("token", data.token, data.expire);

    // 刷新 token 的唯一标识
    storage.set("refreshToken", data.refreshToken, data.refreshExpire);
  }
  // 刷新标识
  async function refreshToken() {
    return new Promise((resolve, reject) => {
      console.log(storage.get("refreshToken"));
      userApi
        .refreshToken({
          refreshToken: storage.get("refreshToken"),
        })
        .then((res) => {
          setToken(res.data);
          resolve(res.data.token);
        })
        .catch((err) => {
          logout();
          reject(err);
        });
    });
  }
  // 用户信息
  const info = ref(data.userInfo);
  // 设置用户信息
  function set(value) {
    info.value = value;
    storage.set("userInfo", value);
  }
  // 获取用户信息
  async function get() {
    const res = await userApi.getUserInfo();
    set(res.data);
    return res.data;
  }
  // 清除用户
  function clear() {
    storage.remove("userInfo");
    storage.remove("token");
    token.value = "";
    info.value = null;
  }
  // 退出
  async function logout() {
    clear();
    router.push("/login");
  }
  return {
    token,
    setToken,
    clear,
    get,
    refreshToken,
    logout,
    info,
  };
});
